import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone' // 引入时区插件
import { isSupportWebp } from '~/composables/useUtil';
import {singleSlashPath} from './jsonUtil'

export const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = singleSlashPath(src)
    script.async = true
    script.onload = () => resolve(src)
    script.onerror = () => reject(new Error(`Failed to load script ${src}`))
    document.head.appendChild(script)
  })
}

export function isScriptLoaded(src) {
  const scripts: any = document.getElementsByTagName('script')
  for (const script of scripts) {
    if (script.src && script.src.endsWith(src)) {
      return true
    }
  }
  return false
}


declare global {
  interface Window {
    global?: any
  }
}

dayjs.extend(utc)
dayjs.extend(timezone)

//获取当前北京时间
export function getBejingTime(type = 'YYYY-MM-DD HH:mm:ss') {
  const now = dayjs().tz('Asia/Shanghai').format(type) // 北京时间（毫秒）
  return now
}

function isStartWith(url: string) {
  if (url?.startsWith('/')) {
    return url
  } else {
    return '/' + url
  }
}
// 定义获取图片地址的方法
export function getPublicImageUrl(projectUrl:string) {
  // const isAndroidWebView = !!window?.android?.openThirdWeb
  // if (isAndroidWebView) {
  //   return '.' + projectUrl
  // }

  if (projectUrl.startsWith('/images') && ['development', 'noad'].includes(import.meta.env.MODE)) {
    return projectUrl
  }
  if (projectUrl.startsWith('http') || projectUrl.startsWith('//')) {
    return projectUrl
  }
  const globalStore = useGlobalStore()
  const { currtAssertApi } = storeToRefs(globalStore)
  const domin = currtAssertApi.value?.url || 'http://unConfig'
  if (domin) return domin + isStartWith(projectUrl)
  return projectUrl
}

export function debounce<T extends (...args: any[]) => void>(func: T, delay: number): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null

  return function (...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      func(...args)
    }, delay)
  }
}

export function formatPulishDate(dateTime = '') {
  const now = new Date(dayjs().tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss')).getTime() // 北京时间（毫秒）
  const postTime = new Date(dateTime).getTime() // 发布时间（毫秒）
  const diff = now - Number(postTime) // 时间差（毫秒）
  let text = ''
  const minute = 1000 * 60
  const hour = minute * 60
  const day = hour * 24
  const week = day * 7
  const month = day * 30
  const year = month * 12
  if (diff / year >= 1) {
    text = `发布于 ${Math.floor(diff / year)} 年之前`
  } else if (diff / month >= 1) {
    text = `发布于 ${Math.floor(diff / month)} 个月之前`
  } else if (diff / week >= 1) {
    text = `发布于 ${Math.floor(diff / week)} 周之前`
  } else if (diff / day >= 1) {
    text = `发布于 ${Math.floor(diff / day)} 天之前`
  } else if (diff / hour >= 1) {
    text = `发布于 ${Math.floor(diff / hour)} 小时之前`
  } else if (diff / minute >= 1) {
    text = `发布于 ${Math.floor(diff / minute)} 分钟之前`
  }
  return text
}

export function debounceWithReturn<T extends (...args: any[]) => any>(
  func: T,
  delay: number
): (...args: Parameters<T>) => Promise<ReturnType<T>> {
  let timeout: ReturnType<typeof setTimeout> | null = null

  return function (...args: Parameters<T>): Promise<ReturnType<T>> {
    return new Promise((resolve) => {
      if (timeout) {
        clearTimeout(timeout)
      }

      timeout = setTimeout(() => {
        resolve(func(...args))
      }, delay)
    })
  }
}

export const clkVideoAction = (item: any) => {
  trackEvent({
    id: item.videoId,
    name: item.title,
    type: 'clklog',
    category: 'videoClick',
    advertiseType: 7,
    channelId: item.channelId,
    topicId: item.topicId
  })
}

export const truncate = (num: number, decimals: number = 0): number => {
  if (decimals < 0) return num

  const factor = Math.pow(10, decimals)

  // 区分正负数，避免负数向下取整变大
  return num >= 0 ? Math.floor(num * factor) / factor : Math.ceil(num * factor) / factor
}

export const playNumFormater = (data: any, category: string) => {
  let result = '0',
    nTotal = 0
  if (category === 'like') {
    nTotal = 1 * data.likeNum
  } else {
    nTotal = 1 * (data.playNums || data.view)
  }

  if (typeof nTotal !== 'undefined' && !isNaN(nTotal) && nTotal > -1) {
    if (-1 < nTotal && nTotal < 1000) {
      result = `${nTotal}`
    } else if (999 < nTotal && nTotal < 1000000) {
      result = `${truncate(nTotal / 1000, 1)}k`
    } else if (nTotal > 999999) {
      result = `${truncate(nTotal / 1000000, 1)}M+`
    }
  }
  return result
}

export function isWebview() {
  const isIOSWebView =
    !!window.webkit && !!window.webkit.messageHandlers && !!window.webkit.messageHandlers.openThirdWeb
  const isAndroidWebView = !!window?.android?.openThirdWeb

  return !!(isIOSWebView || isAndroidWebView)
}

// // 获取操作系统
// export function getMobileOperatingSystem(): string {
//   const userAgent = navigator.userAgent || navigator.vendor || window.opera

//   if (/android/i.test(userAgent)) {
//     return 'Android'
//   }

//   // iOS detection from: http://stackoverflow.com/a/9039885/177710
//   if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
//     return 'IOS'
//   }

//   return 'unknown'
// }
// android 浏览器
// export function isAndroidBrowser(): boolean {
//   return getMobileOperatingSystem() === "Android";
// }
// 现金网最初老的安卓包，包内直接打开域名
export function isAndroidOld(): boolean {
  return window.androidNative && typeof window.androidNative.nativeOpenURL === 'function'
}
//打开外链
export const openThirdWeb = (url: string, type: '_self' | '_blank', options?: ToPlayGameType) => {
  try {
    if (window.TelegramWebviewProxy && window.Telegram) {
      window.Telegram.WebApp.openLink(url)
    } else if (isWebview()) {
      // 处理在三方打包iOS app 中链接跳转链接
      if (isIosBrowser()) {
        window.webkit.messageHandlers.openThirdWeb.postMessage(url)
      } else {
        window?.android?.openThirdWeb(url)
      }
    } else {
      // 如果是android 页签 window.androidNative.nativeOpenURL
      if (isAndroidOld()) {
        window.androidNative.nativeOpenURL(url)
      } else {
        if (options?.wi) {
          options.wi.location.href = url
        } else {
          if (type == '_self') {
            window.location.href = url
          } else {
            window.open(url, type)
          }
        }
      }
    }
  } catch (e) {
    //
  }
}

export function blobToText(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsText(blob)
  })
}

async function joinBase64Sre(promiseList:any):Promise<string>{
  return new Promise((resolve) => {
    promiseList.then(async (item:any) => {
      if(typeof item === 'string'){
        resolve(item.substring(2));
      }else if(item?.data?.value){
        if(typeof item.data.value === 'string'){
          resolve(item.data.value.substring(2));
        }else if(item.data.value instanceof Blob){
          const txtAsync = await blobToText(item.data.value);
          resolve(txtAsync.substring(2));
        }else{
          resolve('')
        }
      }else if(item instanceof Blob){
        const blobText = await item.text();
        resolve(blobText.substring(2));
      }else{
        resolve('')
      }
    }).catch(() => {
      resolve('');
    })
  })
}

function detectImageFormat(base64Data:string) {
  if (base64Data.startsWith('/9j/')) {
    return 'image/jpeg';
  }
  if (base64Data.startsWith('iVBOR')) {
    return 'image/png';
  }
  if (base64Data.startsWith('UklGR')) {
    return 'image/webp';
  }
  return 'image/jpeg';
}

async function getBase64(url?:string) {
  if(!url) return '';
  let pages = 3 //总页
  let current = 1 //当前页
  let promiseList = [] //异步列表
  let urlList = url?.split("?")?.[0].split('.')
  //去除图片后缀并获取图片类型
  let type = urlList.pop();
  let isWebp = ''
  let base = urlList.join('.')

  if(type){
    type = type.toLowerCase();
  }else{
    type = ''
  }
  //是否支持webp
  if (!["gif", "svg", "js"].includes(type) && isSupportWebp()) {
    isWebp = '.w'
  }
  if(base.endsWith('.w')){
    isWebp = '.w'
    base = base.replace(/\.w$/, '');
  }
  //请求剩余页数
  for (current; current <= pages; current++) {
    let baseUrl = `${base}_${current}${pages}${isWebp}.txt`
    promiseList.push(joinBase64Sre($fetch(singleSlashPath(baseUrl),'text')))
  }
  let base64Data = (await Promise.all(promiseList)).join('');
  const mimeType = detectImageFormat(base64Data);
  base64Data = `data:${mimeType};base64,${base64Data}`;
  return base64Data
}

export async function getBase64ListImg(originSrc?:string,imgType?:string,imgDomain?:string){
  let imgResult = originSrc;
  if(!imgResult){
    return '';
  }
  if (!imgType) {
    imgResult = originSrc;
    return imgResult;
  } else {
    if (imgType == 'public'){
      return getPublicImageUrl(imgResult);
    }
    if (imgType == 'videoImage' && originSrc) {
      if (originSrc.startsWith('http')) {
        imgResult = originSrc;
      }else{
        if (originSrc.startsWith('/oss') || originSrc.startsWith('oss')) {
          imgResult =
            imgDomain +
            (originSrc.startsWith('/') ? '' : '/') +
            originSrc;
        } else {
          imgResult =
            imgDomain +
            (originSrc.startsWith('/') ? '' : '/')
            + 'oss/screen-image/' +
            originSrc;
        }
      }
    }
  }
  
  const base64Url = await getBase64(imgResult);
  return base64Url;
}

const imgReg = /<img\b[^>]*\bsrc\s*=\s*["']([^"']*\/oss[^"']*)["'][^>]*>/gi;
export async function replaceImgToBase64InHtml(html:string){
  let resultStr = html;
  const globalStor = useGlobalStore()
  
  const matches = [...html.matchAll(imgReg)]
  const srcList = matches.map(m => m[1]);

  const promises = srcList.map((src:string) => {
    const parts = src.split('.');
    const lastPart = parts[parts.length - 1];
    const lSecoPart = parts[parts.length - 2];
    let urlHandled = src;
    if(lastPart.toLowerCase() === 'js'){
      if(lSecoPart.toLowerCase() === 'w'){
        urlHandled = parts.slice(0, -2).join('.');
      }else{
        urlHandled = parts.slice(0, -1).join('.');
      }
      urlHandled += '.jpg'
    }
    const ossIndex = urlHandled.indexOf('/oss')
    if(ossIndex > -1){
      urlHandled = urlHandled.slice(ossIndex);
    }
    return getBase64ListImg(urlHandled,'videoImage',globalStor.curAdvDomain.url);
  })
  const base64List = (await Promise.all(promises));
  base64List.forEach((item:string,i:number) => {
    resultStr = resultStr.replace(srcList[i],item);
  })
  return resultStr;
}
